export default "__VITE_ASSET__nEY5CHsL__"